import MentalWellnessLogo from "src/checkout/components/pricing/price-breakdown/course-enhancements/images/MentalWellnessLogo.svg";
import SleepLogo from "src/checkout/components/pricing/price-breakdown/course-enhancements/images/SleepLogo.svg";
import AgingMetabolismLogo from "src/checkout/components/pricing/price-breakdown/course-enhancements/images/AgingMetabolismLogo.svg";
import ExerciseLogo from "src/checkout/components/pricing/price-breakdown/course-enhancements/images/ExerciseLogo.svg";
import Glp1Logo from "src/checkout/components/pricing/price-breakdown/product-icon/images/Glp1CompanionProductIon.svg";

import { compassColors } from "src/utils/styling";

export const COURSE_ENHANCEMENT_DATA_MAP = {
  mentalWellnessCoursepack: {
    backgroundColor: compassColors.conch,
    logo: MentalWellnessLogo,
    eventNameMap: {
      learnMore: "ClickedLearnMoreStressEnhancement",
      removed: "RemovedStressEnhancement",
      added: "AddedStressEnhancement",
      modalClosed: "StressEnhancementModalClosed",
    },
    i18nNamespace: "courseEnhancements:mentalWellnessCoursepack",
  },
  agingMetabolismCoursepack: {
    backgroundColor: compassColors.sky,
    logo: AgingMetabolismLogo,
    eventNameMap: {
      learnMore: "ClickedLearnMoreAMEnhancement",
      removed: "RemovedAMEnhancement",
      added: "AddedAMEnhancement",
      modalClosed: "AMEnhancementModalClosed",
    },
    i18nNamespace: "courseEnhancements:agingMetabolismCoursepack",
  },
  sleep: {
    backgroundColor: compassColors.stream,
    logo: SleepLogo,
    eventNameMap: {
      learnMore: "ClickedLearnMoreSleepEnhancement",
      removed: "RemovedSleepEnhancement",
      added: "AddedSleepEnhancement",
      modalClosed: "SleepEnhancementModalClosed",
    },
    i18nNamespace: "courseEnhancements:sleep",
  },
  movement: {
    backgroundColor: compassColors.mint,
    logo: ExerciseLogo,
    eventNameMap: {
      learnMore: "ClickedLearnMoreMovementEnhancement",
      removed: "RemovedMovementEnhancement",
      added: "AddedMovementEnhancement",
      modalClosed: "MovementEnhancementModalClosed",
    },
    i18nNamespace: "courseEnhancements:movement",
  },
  glp1CompanionCoursepack: {
    backgroundColor: compassColors.sky,
    logo: Glp1Logo,
    eventNameMap: {
      learnMore: "MedCompanionLearnMore",
      removed: "MedCompanionRemoved",
      added: "MedCompanionAdded",
      modalClosed: "MedCompanionModalClosed",
    },
    i18nNamespace: "courseEnhancements:glp1CompanionCoursepack",
  },
};
